export function loadScriptStyle(
  {
    doc = window.document,
    script = { type: 'text/javascript', src: '', errorMsg: '' },
    css = { type: 'text/css', rel: 'stylesheet', href: '' },
  }: {
    doc?: Document
    script?: { type?: string; src: string; errorMsg?: string }
    css?: { type?: string; rel?: string; href: string }
  } = {
    doc: window.document,
    script: { src: '', type: 'text/javascript', errorMsg: 'Failed to load script' },
    css: { href: '', type: 'text/css', rel: 'stylesheet' },
  },
) {
  return new Promise((resolve, reject) => {
    if (script?.src) {
      const scriptElement = doc.createElement('script')
      scriptElement.type = script.type ?? 'text/javascript'
      scriptElement.src = script.src

      scriptElement.onload = function () {
        resolve((window as any).videojs)
      }

      scriptElement.onerror = function () {
        reject(new Error(script?.errorMsg))
      }

      doc.head.appendChild(scriptElement)
    }

    if (css?.href) {
      const cssElement = doc.createElement('link')
      cssElement.rel = css.rel ?? 'stylesheet'
      cssElement.type = css.type ?? 'text/css'
      cssElement.href = css.href

      doc.head.appendChild(cssElement)
    }
  })
}

export function loadScript(src: string, cb?: () => void) {
  const existingScript = document.querySelector(`script[src="${src}"]`)
  if (!existingScript) {
    const script = document.createElement('script')
    script.src = src
    if (cb) script.onload = cb
    document.head.appendChild(script)
  } else {
    cb?.()
  }
}

export function loadStyle(href: string) {
  const existingLink = document.querySelector(`link[href="${href}"]`)
  if (!existingLink) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    document.head.appendChild(link)
  }
}
